import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useStore } from "@/lib/store";
import { Check, MapPin } from "lucide-react";

export default function BranchModal({ open, onClose }) {
  const { branches, branch, changeBranch } = useStore();
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md sm:rounded-2xl" data-testid="branch-modal" aria-describedby="branch-modal-desc">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Pilih Cabang</DialogTitle>
          <p id="branch-modal-desc" className="text-sm text-gray-500">Pilih cabang Ella Froze terdekat untuk melihat ketersediaan stok & harga.</p>
        </DialogHeader>
        <div className="space-y-2 mt-2">
          {branches.map((b) => {
            const active = branch?.ID === b.ID;
            return (
              <button
                key={b.ID}
                onClick={() => { changeBranch(b); onClose(); }}
                data-testid={`branch-option-${b.Name.toLowerCase()}`}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border transition ${active ? "bg-red-50 border-[#D32F2F]" : "bg-white border-gray-200 hover:border-gray-300"}`}
              >
                <MapPin className={`w-5 h-5 ${active ? "text-[#D32F2F]" : "text-gray-400"}`} />
                <span className="flex-1 text-left font-medium text-gray-900">{b.Name}</span>
                {active && <Check className="w-5 h-5 text-[#D32F2F]" />}
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
